import { Component, HostListener, Input, OnInit } from '@angular/core';
import { SocialService } from 'src/app/shared/services/angular-service/social.service';
import { POST_LAYOUTS } from 'src/app/shared/constants/static-variable';
import { LocalStorageService } from 'src/app/shared/services/angular-service/local-storage.service';

@Component({
  selector: 'app-feeds-list-page',
  templateUrl: './feeds-list-page.component.html',
  styleUrls: ['./feeds-list-page.component.scss'],
})
export class FeedsListPageComponent implements OnInit {
  @Input() isFeed: boolean = true;
  plan: string;
  @HostListener('window:scroll', [])
  onScrollDown(): void {
    if (window.innerHeight + window.scrollY + 50 >= document.body.offsetHeight) {
      // console.log("agaya niche")
      let page = this.paginationRequest.page + 1;
      this.paginationRequest.page = page;
      if (this.moreFeeds && page < 6) {
        this.getFeedList();
      }
    } else {
      // console.log("Niche nahi hai abhi bhi")
    }
  }

  POST_LAYOUTS = POST_LAYOUTS;
  feedsList: any = [];
  public moreFeeds = false;
  paginationRequest = {
    field: 'name',
    order: 1,
    rows: 10,
    page: 0,
    filter: {},
    totalRecords: 0,
  };
  toRecords: any = 0;
  liveSaleList: any;
  companyData: any;

  constructor(protected socialService: SocialService,
    private localStorageService: LocalStorageService,
  ) {
    // this.getFeedList();
    // this.getLiveSaleList();
  }

  ngOnInit(): void {
    this.feedsList = [];
    this.getFeedList();
    if (this.isFeed) {
      this.getLiveSaleList();
    }
    this.plan = this.localStorageService.getItem('plan');
  }

  postCreatedSuccess() {
    this.getFeedList();
    this.paginationRequest.page = 0;
  }

  getFeedList() {
    let query = {
      // field: this.paginationRequest.field,
      // order: this.paginationRequest.order,
      rows: this.paginationRequest.rows,
      page: this.paginationRequest.page,
      filter: this.paginationRequest.filter,
    };
    if (this.isFeed) {
      this.socialService
        .getPost(query)
        .then((data: any) => {
          // this.feedsList = this.paginationRequest.page === 0 ? data: [...this.feedsList, ...data];
          this.feedsList = [...this.feedsList, ...data.feeds];
          this.paginationRequest.totalRecords = data['totalRecords']
            ? data['totalRecords']
            : 0;
          let toRecords =
            this.paginationRequest.rows * (this.paginationRequest.page + 1);
          this.toRecords =
            this.paginationRequest.totalRecords < toRecords
              ? this.paginationRequest.totalRecords
              : toRecords;
          // To check if we have to paginate or not
          this.moreFeeds = data.next;
        })
        .catch((err: any) => {
          console.log(err);
        });
    } else {
      this.socialService
        .getMyPost(query)
        .then((data: any) => {
          // this.feedsList = this.paginationRequest.page === 0 ? data: [...this.feedsList, ...data];
          this.feedsList = [...this.feedsList, ...data.feeds];
          this.paginationRequest.totalRecords = data['totalRecords']
            ? data['totalRecords']
            : 0;
          let toRecords =
            this.paginationRequest.rows * (this.paginationRequest.page + 1);
          this.toRecords =
            this.paginationRequest.totalRecords < toRecords
              ? this.paginationRequest.totalRecords
              : toRecords;
          // To check if we have to paginate or not
          this.moreFeeds = data.next;
        })
        .catch((err: any) => {
          console.log(err);
        });
    }

  }

  getLiveSaleList() {
    this.socialService
      .getListSaleTransaction()
      .then((data: any) => {
        this.liveSaleList = data.map((sale: any) => {
          sale.timeAgo = this.getTimeAgo(sale.updatedAt);
          return sale;
        });
      })
      .catch((err: any) => {
        console.log(err);
      });
  }

  getTimeAgo(date: string): string {
    const now = new Date();
    const updatedAt = new Date(date);
    const diffInSeconds = Math.floor(
      (now.getTime() - updatedAt.getTime()) / 1000,
    );

    const seconds = diffInSeconds;
    const minutes = Math.floor(diffInSeconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    if (days > 0) {
      return `${days} day${days > 1 ? 's' : ''} ago`;
    } else if (hours > 0) {
      return `${hours} hour${hours > 1 ? 's' : ''} ago`;
    } else if (minutes > 0) {
      return `${minutes} minute${minutes > 1 ? 's' : ''} ago`;
    } else {
      return `${seconds} second${seconds > 1 ? 's' : ''} ago`;
    }
  }
}
